import axios from 'axios';
// config
import { HOST_API } from 'src/config-global';

// ----------------------------------------------------------------------

// axios instance
const axiosInstance = axios.create({ baseURL: HOST_API });

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || 'Something went wrong'
    )
);

// ----------------------------------------------------------------------
// exports
export default axiosInstance;
export { axiosInstance };

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];
  const res = await axiosInstance.get(url, { ...config });
  return res.data;
};

export const fetcherLocal = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  try {
    const res = await axios.get(`http://192.168.1.26:5000${url}`, config);
    return res.data;
  } catch (error) {
    console.error('Local API error:', error);
    throw error;
  }
};

// ----------------------------------------------------------------------
export const endpoints = {

  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  auth: {
    me: '/me',
    login: '/useradmin/login',
    register: '/register',
  },
  business: {
    list: '/business_bp/getBusinesses',
  },

  contacts: {
    list: '/contacts/',
  },


  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/blogs',
    filterList: (filter) => `/blogs?filter=${filter}`,
    details: (slug) => `/blogs/slug/${slug}`,
  },
  currencyExchangeRates: {
    list: '/currency-exchange-rates'
  },
  product: {
    list: '/api/product/list',
    details: '/api/product/details',
    search: '/api/product/search',
  },

  plan: {
    list: '/plans',
    filterList: (filter) => `/plans?filter=${filter}`,
    details: (id) => `/plans/${id}`,
  },

  profileAnalytics: {
    list: '/running-analytics/list',
    filterList: (filter) => `/running-analytics/list?filter=${filter}`,
    details: (id) => `/running-analytics/list/${id}`,
  },


  batch: {
    list: '/batches',
    filterList: (filter) => `/batches?filter=${filter}`,
    details: (id) => `/batches/${id}`,
  },

  dashboard: {
    count: '/analytics/cards',
  },

  subscriptions: {
    list: '/subscriptions',
    filterList: (filter) => `/subscriptions?filter=${filter}`,
    details: (id) => `/subscriptions/${id}`,
  },

  email: {
    list: '/wait-lists',
    filterList: (filter) => `/wait-lists?${filter}`,
    details: (id) => `/wait-lists/${id}`,
  },
  category: {
    list: '/categories',
    filterList: (filter) => `/categories?${filter}`,
    details: (id) => `/categories/${id}`,
  },
  faqCategory: {
    list: '/faq-categories',
    filterList: (filter) => `/faq-categories?filter=${filter}`,
    details: (id) => `/faq-categories/${id}`,
  },
  faq: {
    list: '/faqs',
    filterList: (filter) => `/faqs?filter=${filter}`,
    details: (id) => `/faqs/${id}`,
  },
  contact: {
    list: '/contact-uses',
    filterList: (filter) => `/contact-uses?${filter}`,
    details: (id) => `/contact-uses/${id}`,
  },
  user: {
    list: '/api/users/list',
    filterList: (filter) => `/api/users/list?${filter}`,
    details: (id) => `/api/users/${id}`, // patch
    search: '/api/user/search',
    delete: (id) => `/user/${id}`,
    events: (userId) => `/user/events/${userId}`
  },
  resume: {
    details: (userId) => `/resumes/resume-by-id/${userId}`
  },
  comments: {
    list: '/comments',
    filterList: (filter) => `/comments/${filter}`,
    details: (blogId) => `/comments/${blogId}`,
  },
  jobs: {
    list: '/jobs',
    filterList: (filter) => `/jobs?filter=${filter}`,
    details: (id) => `/jobs/${id}`,
  }

};